<div class="trade-header">
    <div class="header-left">
        <!-- Market Selector Dropdown -->
        <div class="market-selector-dropdown" (click)="toggleDropdown()">
            <div class="pair-info">
                <span class="pair-name">{{ selectedPair }} Options</span>
                <i class="fas" [ngClass]="isDropdownOpen ? 'fa-caret-up' : 'fa-caret-down'"></i>
            </div>

            <!-- Dropdown Menu -->
            <div class="dropdown-menu-custom" *ngIf="isDropdownOpen" (click)="$event.stopPropagation()">
                <div class="dropdown-item" *ngFor="let pair of availablePairs" (click)="selectPair(pair)">
                    <span [class.active-pair]="pair === selectedPair">{{ pair }} Options</span>
                </div>
            </div>
        </div>

        <!-- View Toggles -->
        <div class="view-toggles">
            <div class="toggle-icon" [class.active]="currentViewMode === 'TABLE'" (click)="setViewMode('TABLE')"
                title="Options Chain">
                <i class="fas fa-list"></i>
            </div>
            <div class="toggle-icon" [class.active]="currentViewMode === 'CHART'" (click)="setViewMode('CHART')"
                title="Chart">
                <i class="fas fa-chart-line"></i>
            </div>
        </div>

        <!-- <div class="divider"></div> -->

        <!-- <div class="market-stats">
            <div class="stat-item">
                <span class="stat-value green">42,150.00</span>
                <span class="stat-label">Index Price</span>
            </div>
            <div class="stat-item">
                <span class="stat-value red">-1.20%</span>
                <span class="stat-label">24h Change</span>
            </div>
            <div class="stat-item mobile-hide">
                <span class="stat-value">25,402</span>
                <span class="stat-label">24h Volume (BTC)</span>
            </div>
        </div> -->
    </div>

    <div class="header-right">
        <div class="header-links mobile-hide">
            <!-- <span>Training Manual</span>
            <span>API</span> -->
        </div>
        <i class="fas fa-cog text-muted" style="cursor: pointer;"></i>
    </div>
</div>